import React, { Component } from 'react';
import {Link}from 'react-router-dom';
import ReactDOM from 'react-dom';

// images

import InfoJumb1 from './images/infoJumbo1.jpg';
import InfoJumb2 from './images/infoJumbo2.jpg';
import InfoJumb3 from './images/infoJumbo3.jpg';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Aalbersfarina extends Component {
  render() {
    var dataNews;
    var dataVideo;
    var builtTmpNews;
    var builtTmpVideos;
    var parseStringNews = require('xml2js').parseString;
    fetch('/newsData.xml')
    .then((r) => r.text())
    .then(text  => {
      parseStringNews(text, function (err, result) {
          dataNews=result;
          var tmpOV = JSON.parse(JSON.stringify(result));
          dataNews= tmpOV.NewsList.News;
          var newDataNews = [];
          for (var ele in dataNews) {
            if (dataNews[ele].Supplier[0].includes("aalbers farina")){
              newDataNews.push(dataNews[ele]);
            }
          }
          dataNews = newDataNews;
          builtTmpNews = dataNews.map((element) =>
                <Col xs={12} sm={6} md={4} lg={3} className="newsItem">
                  <div className="newsCont news-supplier">
                    <img src={`../news/${element.Image}`} alt={element.Title} id={`image ${element.Title}`} className={`newsImg${element.classType}`} />
                    <video id="background-video" className={`newsVideo${element.classType}`} loop autoPlay id={`video ${element.Title}`} playsInLine="true">
                        <source src={`../videos/${element.FileShort}`} type="video/mp4" />
                        Your browser does not support the video tag.
                      </video>
                    <h4>{element.Title}</h4>
                    <h5>{element.Supplier}</h5>
                    <hr/>
                    <p className="newsText">{element.Text}</p>
                    <hr/>
                    <p className="newsDate">{element.Date}</p>
                  </div>
                </Col>

              );
          }.bind(this));
          this.builtElement = ReactDOM.render(builtTmpNews, document.getElementById('newsRoot'));
      });
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/SuB">SuB</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>aalbers farina</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="aalbers farina Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>aalbers | farina</h1>
          <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="aalbers farina Produktion"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="aalbers farina Headquater"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="aalbers farina Blechlager"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden md={7}>
              <h4>aalbers|farina ist eine Schwester des bekannten niederländischen Metallunternehmens aalbers|wico und entwickelt moderne Lagersysteme zur Blech und Langgutlagerung. Durch das intelligente Desing mit Schubladen kann die Lagerkapazität im Vergleich zu konventionellen Lösungen um 50% erhöht werden.
                Die Entwicklung einer automatisierten Lösung ermöglicht es Abläufe zu optimieren und jederzeit das richtige Blech bereit zu halten.
            </h4>
            </Col>
            <Col xs={12}  smHidden mdHidden lgHidden>
              <h4>aalbers|farina ist eine Schwester des bekannten niederländischen Metallunternehmens aalbers|wico und entwickelt moderne Lagersysteme zur Blech und Langgutlagerung.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.aalbersfarina.nl/de/home" rel="noopener" rel="noreferrer" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid className="shortDesc">
            <Row>
              <Col xsHidden  sm={4} md={4}>

                <h5>Lageroptimierung durch Kapazitätssteigerung um bis zu 50%</h5>
              </Col>
              <Col xsHidden  sm={4} md={4}>

                  <h5>Voll automatisiertes System</h5>
              </Col>
              <Col xsHidden  sm={4} md={4}>

                    <h5>Made in Europe</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                <h4>&#9658; &nbsp; Lageroptimierung durch Kapazitätssteigerung um bis zu 50%</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h4>&#9658; &nbsp; Voll automatisiertes System</h4>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h4>&#9658; &nbsp; Made in Europe</h4>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <br/>
          <center>
          <h1>Produkte</h1>
          </center>
          <br/><br/>
          <Row className="show-grid">
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/aalbersfarina/Blechregale"><h4 className="buttonBlue">Blechregale</h4>
                  Weniger Gabelstaplerbewegungen, schnell das richtige Blech. Mit unseren Blechlagern lassen die Handhabungszeiten sich um 80 % verkürzen und viele hundert Quadratmeter Platz sparen.
                  </Link>
                </div>
            </center>
            </Col>
            <Col  xs={12} sm={6}>
              <center>
                <div className="productsButton">
                  <Link to="/Suppliers/aalbersfarina/Langgutlager"><h4 className="buttonBlue" >Langgutregale</h4>
                  Rohre und Profile einfacher auffinden und keine lästigen Vorräte mehr im Weg am Arbeitsplatz. In unseren automatischen Langgutlagerung lässt sich auch Restmaterial ordentlich verstauen, sodass es noch effizienter genutzt werden kann.
            </Link>
            </div>
            </center>
            </Col>

          </Row>

        </Grid>
        <br/>
      </section>
      <hr/>
      <section>
        <br/>
        <center>
        <h1>News</h1>
        </center>
        <br/><br/>
        <center>
        <div className="newsAtSupplier" id="newsRoot"/>
        </center>
        <br/><br/><br/>
      </section>
        </div>
    );
  }
}

export default Aalbersfarina;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/aalbers/mainPageSup.js